module.exports = __webpack_public_path__ + "img/Systemconstruction.71035b21.svg";